import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/properties/usePropertiesQueryKeys.ts
var t = e("properties", {
	list: (e) => e ? ["list", e] : ["list"],
	map: (e) => ["map", e],
	mapList: (e) => ["map-list", e],
	mapSuggestions: (e) => ["map-suggestions", e],
	mapPriceDistribution: (e) => ["map-price-distribution", e],
	nearby: (e, t) => e ? t ? [
		"nearby",
		e,
		t
	] : ["nearby", e] : ["nearby"],
	searchSuggest: (e) => ["search-suggest", e],
	polygon: (e, t) => [
		"polygon",
		e,
		t
	],
	listing: (e) => e ? ["listing", e] : ["listing"],
	property: (e) => e ? ["property", e] : ["property"],
	publicProperty: (e, t) => e ? t ? [
		"public-property",
		e,
		t
	] : ["public-property", e] : ["public-property"],
	siblings: (e, t) => e ? t ? [
		"siblings",
		e,
		t
	] : ["siblings", e] : ["siblings"],
	images: (e, t) => t ? [
		"images",
		e,
		t
	] : ["images", e],
	gallery: (e) => e ? ["gallery", e] : ["gallery"],
	hotelGallery: (e) => [
		"gallery",
		e,
		"hotel"
	],
	unitGallery: (e, t) => [
		"gallery",
		e,
		"unit",
		t
	],
	unit: (e) => e ? ["unit", e] : ["unit"],
	room: (e, t) => e ? t === void 0 ? ["room", e] : [
		"room",
		e,
		t
	] : ["room"],
	guestFeed: (e) => ["guest-feed", e],
	guestHome: () => ["guest-home"],
	guestHomePersonal: () => ["guest-home-personal"],
	hostFeed: (e) => e ? ["host-feed", e] : ["host-feed"]
});
//#endregion
export { t as propertyQueryKeys };
